import { combineReducers } from 'redux';
import resources from 'automation-ui-canvas/reducers/resources';
import auth from 'automation-ui-canvas/reducers/auth';
import embed from 'automation-ui-canvas/reducers/embed';
import automation from 'automation-ui-canvas/reducers/automation';
import platformFlowsApplication from 'automation-ui-canvas/reducers/platformFlowsApplication';
import localStorage from 'automation-ui-canvas/reducers/localStorage';
// @ts-expect-error untyped module
import Notifications from 'ReduxMessenger/reducers/Notifications';
const RootReducer = combineReducers({
  auth,
  resources,
  automation,
  embed,
  platformFlowsApplication,
  localStorage,
  notifications: Notifications
});

// The top-level state of our redux store

// Types uses of the getState argument in thunk actions

export default RootReducer;